/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PracticeInternshipAllocationReportDTO
 */
export interface PracticeInternshipAllocationReportDTO {
	/**
	 *
	 * @type {string}
	 * @memberof PracticeInternshipAllocationReportDTO
	 */
	id?: string;
	/**
	 *
	 * @type {string}
	 * @memberof PracticeInternshipAllocationReportDTO
	 */
	name?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof PracticeInternshipAllocationReportDTO
	 */
	faculty?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof PracticeInternshipAllocationReportDTO
	 */
	studyProgram?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof PracticeInternshipAllocationReportDTO
	 */
	department?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof PracticeInternshipAllocationReportDTO
	 */
	email?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof PracticeInternshipAllocationReportDTO
	 */
	phone?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof PracticeInternshipAllocationReportDTO
	 */
	group?: string | null;
	/**
	 *
	 * @type {number}
	 * @memberof PracticeInternshipAllocationReportDTO
	 */
	applications?: number;
}

export function PracticeInternshipAllocationReportDTOFromJSON(
	json: any
): PracticeInternshipAllocationReportDTO {
	return PracticeInternshipAllocationReportDTOFromJSONTyped(json, false);
}

export function PracticeInternshipAllocationReportDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PracticeInternshipAllocationReportDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		name: !exists(json, "name") ? undefined : json["name"],
		faculty: !exists(json, "faculty") ? undefined : json["faculty"],
		studyProgram: !exists(json, "studyProgram")
			? undefined
			: json["studyProgram"],
		department: !exists(json, "department") ? undefined : json["department"],
		email: !exists(json, "email") ? undefined : json["email"],
		phone: !exists(json, "phone") ? undefined : json["phone"],
		group: !exists(json, "group") ? undefined : json["group"],
		applications: !exists(json, "applications")
			? undefined
			: json["applications"],
	};
}

export function PracticeInternshipAllocationReportDTOToJSON(
	value?: PracticeInternshipAllocationReportDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		name: value.name,
		faculty: value.faculty,
		studyProgram: value.studyProgram,
		department: value.department,
		email: value.email,
		phone: value.phone,
		group: value.group,
		applications: value.applications,
	};
}
